module.exports = "../../../../platform/assets/pageMainIcon/youth_yewushezhilei3.svg";